import React, { FC } from 'react'
import Header from 'marketing-components/dist/components/organisms/header'
import 'marketing-components/dist/components/organisms/header/less/header.less'
import useWorldReady from '../lib/useWorldReady'

const StorePageHeader: FC = () => {
  const { formatMessage } = useWorldReady()
  const contentLoggedOut = {
    minimalHeader: {
      labelMenuButton: formatMessage('main.storePage.header.labelMenuButton'),
      labelClose: formatMessage('main.storePage.header.labelClose'),
      logo: {
        text: 'PayPal',
        href: '/webapps/mpp/home'
      },
      headerButtons: []
    },
    config: {
      useMinimalHeader: true
    }
  }
  return (
    <Header
      content={contentLoggedOut}
      className="store-page__header logged-out-header"
    />
  )
}

export default StorePageHeader
